import { render, staticRenderFns } from "./BackofficeChatbot.vue?vue&type=template&id=ae9da64a&scoped=true&"
import script from "./BackofficeChatbot.vue?vue&type=script&lang=js&"
export * from "./BackofficeChatbot.vue?vue&type=script&lang=js&"
import style0 from "./BackofficeChatbot.vue?vue&type=style&index=0&id=ae9da64a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9da64a",
  null
  
)

export default component.exports